import { useState, useEffect } from "react";
import { Box, Chip, LinearProgress, Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LinkProgress(props: {
  validity_end_date: string;
  validity_start_date: string;
}) {
  const [progress, setProgress] = useState<number>();
  const { t } = useTranslation();

  const getProgress = (
    validity_end_date: string,
    validity_start_date: string
  ) => {
    var now = new Date();
    var end = new Date(validity_end_date);
    var start = new Date(validity_start_date);

    const duration = end.getTime() - start.getTime();
    if (now.getTime() < start.getTime()) {
      setProgress(0);
    } else if (now.getTime() > end.getTime()) {
      setProgress(100);
    } else if (
      now.getTime() > start.getTime() &&
      now.getTime() < end.getTime()
    ) {
      setProgress(((now.getTime() - start.getTime()) / duration) * 100);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      getProgress(props.validity_end_date, props.validity_start_date);
      if (progress === 100) {
        clearInterval(interval);
      }
    }, 1000);
  }, []);

  return (
    <Box>
      {progress === 100 ? (
        <Chip label={t("Expired")} variant="filled" color="error"></Chip>
      ) : progress === 0 ? (
        <Chip label={t("Pending")} variant="filled" color="warning"></Chip>
      ) : progress && progress > 0 && progress < 100 ? (
        <LinearProgress
          variant="determinate"
          value={progress}
          color="primary"
          sx={{ width: 160, height: 8, borderRadius: 10 }}
        />
      ) : (
        <Skeleton variant="rectangular" width={160} height={40} />
      )}
    </Box>
  );
}
